import { Box, Divider, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import "../../../styles/homePage.css";
import ClientsCard from "./clientsCard/ClientsCard";
import Slider from "react-slick";


const StyledTypography = styled(Typography)(({theme}) => ({
  textAlign: 'center',
  fontSize: '2.1rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  }
}))

const MainBox = styled(Box)(({theme}) => ({
  height: "90vh",
  backgroundColor: "rgb(215, 191, 244)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  margin: theme.spacing(2, 0),
  padding: theme.spacing(2, 3),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    padding: theme.spacing(0, 1),
  }
}))

const TestimonialBox = styled(Box)(({theme}) => ({
   height: "70%",
   width: "100%",
   display: 'grid',
   columnGap: 2,
   gridTemplateColumns: 'auto auto auto auto',
  [theme.breakpoints.down('sm')]: {
    // display: 'none',
  }
}))

const TestimonialBoxSmall = styled(Box)(({theme}) => ({
   height: "35%",
   width: "90%",
   margin: theme.spacing(5, 0),
}))

const QuoteTypography = styled(Typography)(({theme}) => ({
  textAlign: 'center',
  fontSize: '1.3rem',
  // marginTop: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  }
}))




function ClientsAndTestimonials() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
  

  const Clients = [
    {
      "category": "Large Corporations",
      "description": "Fortune 500 companies, industry leaders looking to enhance their market intelligence, optimize operations, or enter new markets.",
      "example_industries": ["Automotive", "Pharmaceuticals", "Technology", "Manufacturing"]
    },
    {
      "category": "Small and Medium Enterprises (SMEs)",
      "description": "Growing companies needing insights to expand their business, enter new verticals, or strengthen their competitive edge.",
      "example_industries": ["Retail", "E-commerce", "Startups", "Financial Services"]
    },
    {
      "category": "Investment Firms & Venture Capitalists",
      "description": "Investors looking for detailed market research to make informed decisions on mergers, acquisitions, or funding opportunities.",
      "example_industries": ["Fintech", "Real Estate", "Energy & Sustainability", "Biotechnology"]
    },
    {
      "category": "Consulting Firms",
      "description": "Businesses that provide management or strategy consulting and require in-depth industry research, competitive analysis, and tailored reports.",
      "example_industries": ["Business Consulting", "Strategy Consulting", "HR Consulting"]
    },
    {
      "category": "Government Agencies & Regulatory Bodies",
      "description": "Organizations needing market insights for policy-making, strategic planning, and regulation development.",
      "example_sectors": ["Healthcare", "Energy", "Public Infrastructure"]
    },
    {
      "category": "Nonprofits and NGOs",
      "description": "Organizations focused on sustainability, social change, and environmental impact, which need industry reports to guide initiatives.",
      "example_sectors": ["Environmental NGOs", "Public Health Organizations", "Education-focused NGOs"]
    },
    {
      "category": "Tech Startups & Innovators",
      "description": "Early-stage companies requiring market research to validate their ideas, identify competitors, and define target audiences.",
      "example_industries": ["AI & Machine Learning", "IoT", "Generative AI"]
    },
    {
      "category": "Industry Associations & Trade Groups",
      "description": "Groups requiring aggregated research on market trends, industry standards, and competitive landscapes to aid in policy-making and advocacy.",
      "example_sectors": ["Industry Trade Groups", "Chambers of Commerce"]
    }
  ]

  const settings = {
    dots: false, // Show navigation dots
    arrows: false, // hide nex/previous slide arrow buttons
    infinite: true, // Infinite loop scrolling
    speed: 2500, // Transition speed
    slidesToShow: 1, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Auto-slide enabled
    autoplaySpeed: 5000, // 5 seconds per slide
    rows: isMobile ? 1 : 2, // Number of rows per slide
    slidesPerRow: isMobile ? 1 : 2, // Number of items per row
  };

  return (
    <MainBox>
      <Box
        sx={{
          width: "100%",
          height: "10%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <StyledTypography
          fontWeight={600}
          sx={{ fontFamily: "sans-serif" }}
        >
          Who can be our Potential Clients
        </StyledTypography>
      </Box>

      { !isMobile ?
      <TestimonialBox>
        {Clients.map((items, index) => (
          <Box key={index} sx={{ width: '23vw', display: 'flex', alignItems: 'start', justifyContent: 'left' }} >
            <ClientsCard {...items} />
            {
              index % 4 !==3 && (
                <Divider orientation="vertical" flexItem sx={{ pr: 2, borderRight: '2px dashed black', height: "80%", }} />
              )
            }
          </Box>
        ))}
      </TestimonialBox>
      
      :
      
      <TestimonialBoxSmall>
        <Slider {...settings} >

        {Clients.map((items, index) => (
          <Box 
            sx={{
              display: "flex",
            }}
          >
            <ClientsCard key={index} {...items} />
          </Box>
        ))}
        
        </Slider>
      </TestimonialBoxSmall>

}

      <Box sx={{ height: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <QuoteTypography fontFamily={'sans-serif'} sx={{ textAlign: 'center', }} >
          <b style={{ fontSize: '3rem' }} >“</b>DataPi has been significant in our strategic planning. Their customized research reports gave us the confidence to enter new markets with a targeted approach. Their industry insights were a game-changer for our expansion strategy.<b style={{ fontSize: '3rem' }} >”</b>
        </QuoteTypography>
      </Box>
    </MainBox>
  );
}

export default ClientsAndTestimonials;
